import { mapBackendServiceToIcon } from "./serviceIconMap";
import {
  Transaction,
  TransactionDetail,
  TransactionDetailDto,
  TransactionDto,
  TransactionStep,
  TransactionStepDto,
} from "./types";

export function mapTransactionDtoToRow(dto: TransactionDto): Transaction {
  return {
    id: dto.id,
    agency: dto.agency,
    date: dto.date,
    operationType: dto.operationType,
    clientName: dto.clientName,
    contractNumber: dto.contractNumber,
    from: dto.accountNameFrom,
    fromIcon: mapBackendServiceToIcon(dto.serviceFrom),
    to: dto.accountNameTo,
    toIcon: mapBackendServiceToIcon(dto.serviceTo),
    amount: dto.amount,
    currency: dto.currency,
    status: dto.status,
    originalStatus: dto.originalStatus,
    source: dto.source,
  };
}

export function mapTransactionStepDto(
  step: TransactionStepDto,
): TransactionStep {
  return {
    id: step.id,
    accountId: step.account_id,
    type: step.type,
    status: step.success ? "success" : "error",
    error: step.errors,
  };
}

export function mapTransactionDetailDto(
  dto: TransactionDetailDto,
): TransactionDetail {
  return {
    externalId: dto.external_id,
    status: dto.status,
    steps: dto.steps.map(mapTransactionStepDto),
  };
}
